import React, { Fragment } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Autocomplete } from '@material-ui/lab'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { Grid, TextField, Typography } from '@material-ui/core'

const SummaryFormItems = ({
  disabled = false,
  index,
  name,
  users,
  planAction,
  componentIndex,
  governanceProject,
  responsibleValue,
  setResponsibleValue,
}) => {
  const { control, errors, watch } = useFormContext()

  const componentError = errors?.evidencePlanActions?.[componentIndex]

  const activityDeadlineDate = watch('deadlineDate')
  const endDate = moment(governanceProject?.endDate)
  const minDate = moment(governanceProject?.startDate)
  const maxDate = moment.min(endDate, moment(activityDeadlineDate))

  return (
    <Fragment>
      <Controller
        as={<Fragment />}
        name={`${name}.planActions.${index}.status`}
        control={control}
      />
      <Controller
        as={<Fragment />}
        name={`${name}.planActions.${index}.originId`}
        control={control}
      />
      <Grid item xs={12} md={6}>
        <Typography variant="h5" gutterBottom>
          Responsável *
        </Typography>
        {/* Devido à versão do react-hook-form (v5), não é possível utilizar a propriedade 'render' no Controller.
            Além disso, a propriedade 'as' não é compatível com props adicionais do Controller, o que impede o correto 
            funcionamento com componentes que sofrem re-renderização dinâmica, como o Autocomplete, por isso a não 
            utilização do mesmo para esse caso. */}
        <Controller
          as={<Fragment />}
          name={`${name}.planActions.${index}.responsible`}
          control={control}
        />
        <Autocomplete
          options={users}
          getOptionLabel={(option) => option?.name || ''}
          getOptionSelected={(option, value) =>
            option.id === value.id || value.id === 0
          }
          disabled={disabled}
          value={responsibleValue || null}
          onChange={(_, value) =>
            setResponsibleValue && setResponsibleValue(value)
          }
          defaultValue={planAction?.responsible || responsibleValue}
          renderInput={(params) => (
            <TextField
              {...params}
              error={!!componentError?.planActions?.[index]?.responsible}
              helperText={
                componentError?.planActions?.[index]?.responsible?.message ||
                componentError?.planActions?.[index]?.responsible?.id?.message
              }
              disabled={disabled}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Typography variant="h5" gutterBottom>
          Prazo *
        </Typography>
        <Controller
          as={
            <KeyboardDatePicker
              inputVariant="outlined"
              format="DD/MM/yyyy"
              error={!!componentError?.planActions?.[index]?.deadlineDate}
              helperText={
                componentError?.planActions?.[index]?.deadlineDate?.message
              }
              onChange={(newValue) => ({ value: newValue })}
              disabled={disabled}
              minDate={minDate}
              maxDate={maxDate}
              disablePast
              fullWidth
            />
          }
          control={control}
          name={`${name}.planActions.${index}.deadlineDate`}
          mode="onChange"
          defaultValue={planAction?.deadlineDate || activityDeadlineDate}
        />
      </Grid>
    </Fragment>
  )
}

SummaryFormItems.propTypes = {
  disabled: PropTypes.bool,
  index: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  users: PropTypes.array,
  planAction: PropTypes.object,
  governanceProject: PropTypes.object,
  componentIndex: PropTypes.number.isRequired,
  responsibleValue: PropTypes.object,
  setResponsibleValue: PropTypes.func.isRequired,
}

export default SummaryFormItems
